import { NewOrder_OrderFieldsFragment } from '@/types';
import { OfflineOrderData } from '@/adapters/offline-mode';
import { useGetOfflineTotalPrice } from './use-get-offline-total-price';

export const useOfflineDraftOrderToOrderData = (
  deliveryDate: string | undefined,
  draftOrder: NewOrder_OrderFieldsFragment | null,
  restaurantUUID: string,
  supplierUUID: string,
): OfflineOrderData | null => {
  const orderTotalPrice = useGetOfflineTotalPrice(
    draftOrder?.orders_items ?? [],
  );
  if (!draftOrder) {
    return null;
  }
  return {
    deliveryDate,
    fulfillmentType: draftOrder.fulfillment_type,
    orderNotes: draftOrder.notes,
    ordersItems: draftOrder.orders_items,
    orderTotalPrice,
    poNumber: draftOrder.po_number,
    restaurantUUID,
    supplierUUID,
    timeslotEnd: draftOrder.fulfillment_timeslot_end,
    timeslotStart: draftOrder.fulfillment_timeslot_start,
    variantPacksPriceEditMapAtTimeOfOrder: null,
  };
};
